import type { CardRootProps } from '@chakra-ui/react';
import { Card } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

export interface PanelProps extends CardRootProps {
  title?: string;
  rounded?: string;
  bodyProps?: React.ComponentProps<typeof Card.Body>;
}

export const Panel = ({
  children,
  title,
  rounded = 'xl',
  bodyProps,
  ...props
}: PropsWithChildren<PanelProps>) => {
  return (
    <Card.Root rounded={rounded} {...props}>
      {title && (
        <Card.Header>
          <Card.Title>{title}</Card.Title>
        </Card.Header>
      )}
      <Card.Body {...bodyProps}>{children}</Card.Body>
    </Card.Root>
  );
};
